export default __webpack_public_path__ + "static/media/ereader.bc62baf7.svg";